export default __webpack_public_path__ + "static/media/subcaticon.ff71fb15.svg";